import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
    *{
        box-sizing: border-box;
        font-family: 'Lato', sans-serif;
    }

    body {
        height: 100%;
        width: 100%;
        background-color: #eef2f5;
        margin: 0;
    }

    label {
        color:#333;
        font-size:14px;
        font-weight: 300;
        margin-bottom: 0;
        margin-top: 5;
    }

    textarea {
        border: 1px solid #ddd;
        background-color: #fff;
        width:100%;
        color:#888;
        padding:5px 10px;
        text-align: left;
        margin:5px 0 15px;
        resize: none;
        box-sizing: content-box;
    }

    hr {
        margin: 7px 0;
    }

    /* This removes the arrows from input numbers */
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
        -webkit-appearance: none; 
        margin: 0; 
    }
    

    ::-webkit-scrollbar {
        
        @media (min-width: 740px) {
            width: 1rem;
            height: 5px;
            padding: 2px;
        }
    }

    /* Track */
    ::-webkit-scrollbar-track {
        //-webkit-box-shadow: ${props => `inset 0 0 4px ${props.theme.colors.grey500}`}; 
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: ${props => props.theme.colors.grey600}; 
    }
    ::-webkit-scrollbar-thumb:window-inactive {
        background: ${props => props.theme.colors.grey600}; 
    }

    @media (max-width: 740px) {
        tr{
            height: 30px !important;
        }
        th{
            height: 30px !important;
            padding: 4px !important;
        }
        td{
            height: 30px !important;
            padding: 8px 5px !important;
            font-size: 11px !important;
        }
    }

    @media (max-width: 740px) {
        label{
            font-size: 12px;
        }
    }
`